import { z } from 'zod';
/**
 * Preview module query schemas — batch-2 zod migration (gh#750).
 * NOTE: z.coerce.boolean() is FORBIDDEN — use z.enum(['true','false']).transform(...)
 */
/** GET /api/preview/context?name= */
export const previewContextQuerySchema = z.object({
    name: z.string().min(1, 'name query param required'),
});
/**
 * GET /api/preview/?includeTorndown=
 * Preserves existing behavior: 'true' OR '1' both count as truthy.
 */
export const previewListQuerySchema = z.object({
    includeTorndown: z
        .string()
        .optional()
        .transform((v) => v === 'true' || v === '1'),
});
//# sourceMappingURL=preview.schema.js.map